
import {FileVM} from "@cmodules/checklist/assets/data/types"

// Image marker definition
class ImageMarkerVM {
  uuid: string;
  file_id: number;
  options: {
    width?: string;
    height?: string;
    img_width?: number;
    img_height?: number;
  } | null;
  items: any[];
  file: FileVM;

  constructor(data?: Partial<ImageMarkerVM>) {
    this.uuid = data?.uuid || ''
    this.file_id = data?.file_id || 0
    this.options = data?.options || null
    this.items = data?.items || []
    this.file = data?.file || new FileVM()
  }
}

// Image markers definition
class ImageMarkersVM {
  [key: string]: ImageMarkerVM;

  constructor(data?: Record<string, ImageMarkerVM>) {
    if (data) {
      Object.keys(data).forEach(key => {
        this[key] = data[key] instanceof ImageMarkerVM ? data[key] : new ImageMarkerVM(data[key])
      })
    }
  }
}

export {ImageMarkersVM, ImageMarkerVM}
